import type { PublicCheckout } from './contract';

export const sampleCheckout: PublicCheckout = {
  checkoutId: 'demo',
  payment: { methods: ['pix', 'card', 'boleto'], maxInstallments: 12, gateway: 'STRIPE', publishableKey: '', walletsEnabled: false },
  refundDays: 7,
  acceptsCoupon: true,
  thankYouUrl: '',
  tracking: { pixels: [] },
  product: {
    name: 'Método Acelerador de Vendas 3.0',
    description:
      'O passo a passo completo para sair do zero e faturar suas primeiras 10 mil reais com produtos digitais, mesmo sem audiência.',
    coverImage:
      'https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1200&q=80',
    productType: 'course',
  },
  offer: {
    offerId: 'of_principal',
    name: 'Acesso Completo + Bônus',
    price: { amount: '297.000', currency: 'BRL' },
  },
  orderBumps: [
    {
      id: 'bump_mentoria',
      targetOfferId: 'of_mentoria',
      title: 'Mentoria em Grupo (4 encontros ao vivo)',
      description: 'Tire suas dúvidas direto comigo e acelere seus resultados em 30 dias.',
      callToAction: 'Adicionar à compra',
      imageUrl: '',
      price: { amount: '97.000', currency: 'BRL' },
    },
    {
      id: 'bump_templates',
      targetOfferId: 'of_templates',
      title: 'Pacote de 50 Templates Prontos',
      description: 'Modelos editáveis de páginas, e-mails e criativos para vender mais rápido.',
      callToAction: 'Adicionar à compra',
      imageUrl: '',
      price: { amount: '47.000', currency: 'BRL' },
    },
  ],
  presentation: {
    template: 'classic',
    accent: 'green',
    bannerUrl: '',
    blocks: { timer: true, reviews: true, bump: true, security: true },
    fields: { name: true, email: true, phone: true, document: true },
    market: 'national',
  },
  funnel: [],
};

export const sampleRoundingCheckout: PublicCheckout = {
  ...sampleCheckout,
  checkoutId: 'arredondamento',
  product: { ...sampleCheckout.product, name: 'Precisão monetária USD',
    description: 'Cenário simulado de arredondamento do checkout.', coverImage: '' },
  offer: { offerId: 'qa-rounding-offer', name: 'Compra simulada', price: { amount: '20.105', currency: 'USD' } },
  payment: { ...sampleCheckout.payment, methods: ['card'], maxInstallments: 1 },
  presentation: { ...sampleCheckout.presentation, market: 'global',
    fields: { name: true, email: true, phone: false, document: false } },
  orderBumps: [],
  acceptsCoupon: false,
};

export const sampleSubscriptionCheckout: PublicCheckout = {
  ...sampleCheckout,
  checkoutId: 'assinatura',
  product: {
    name: 'Clube de Assinatura Premium',
    description:
      'Acesso contínuo a aulas novas toda semana, comunidade fechada e uma mentoria ao vivo por mês.',
    coverImage:
      'https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1200&q=80',
    productType: 'course',
  },
  offer: {
    offerId: 'of_assinatura',
    name: 'Plano Mensal',
    price: { amount: '49.000', currency: 'BRL' },
  },
  orderBumps: [],
  subscription: {
    planId: 'plan_mensal',
    value: { amount: '49.000', currency: 'BRL' },
    billingPeriodUnit: 'MONTH',
    billingPeriodCount: 1,
    trialDays: 7,
  },
};
